module.exports = __webpack_public_path__ + "img/s7pLogo2.5f07f56c.svg";